import { SearchDropDownItem } from "src/models/shared/filter.model";
import { MapMode } from "src/services/map/map-state.service";

const marketDefault = 3;
const propertiesDefault = 3;
const newDwellingsDefault = 1;

const address: SearchDropDownItem[] = [
    {
        data: null,
        isSelected: false,
        key: "address",

        subtext: "A-Å",
    },
    {
        data: null,
        isSelected: false,
        key: "-address",

        subtext: "Å-A",
    },
];
const sortDate: SearchDropDownItem[] = [
    {
        data: null,
        isSelected: false,
        key: "sortDate",

        subtext: "lav-høy",
    },
    {
        data: null,
        isSelected: false,
        key: "-sortDate",

        subtext: "høy-lav",
    },
];
const calculatedArea: SearchDropDownItem[] = [
    {
        data: null,
        isSelected: false,
        key: "residentialMeasuredArea",

        subtext: "lav-høy",
    },
    {
        data: null,
        isSelected: false,
        key: "-residentialMeasuredArea",

        subtext: "høy-lav",
    },
];
const assumedValue: SearchDropDownItem[] = [
    {
        data: null,
        isSelected: false,
        key: "assumedValue",

        subtext: "lav-høy",
    },
    {
        data: null,
        isSelected: false,
        key: "-assumedValue",

        subtext: "høy-lav",
    },
];
const price: SearchDropDownItem[] = [
    {
        data: null,
        isSelected: false,
        key: "price",

        subtext: "lav-høy",
    },
    {
        data: null,
        isSelected: false,
        key: "-price",

        subtext: "høy-lav",
    },
];
const regDate: SearchDropDownItem[] = [
    {
        data: null,
        isSelected: false,
        key: "regDate",

        subtext: "lav-høy",
    },
    {
        data: null,
        isSelected: false,
        key: "-regDate",

        subtext: "høy-lav",
    },
];
const projectName: SearchDropDownItem[] = [
    {
        data: null,
        isSelected: false,
        key: "projectName",
        subtext: "A-Å",
    },
    {
        data: null,
        isSelected: false,
        key: "-projectName",
        subtext: "Å-A",
    },
];
const percentageSold: SearchDropDownItem[] = [
    {
        data: null,
        isSelected: false,
        key: "percentageSold",
        subtext: "lav-høy",
    },
    {
        data: null,
        isSelected: false,
        key: "-percentageSold",
        subtext: "høy-lav",
    },
];

export enum ListOrigin {
    SearchResult,
    PopUpEstate,
    FavouriteList,
}

const ListSortItems_Properties: SearchDropDownItem[] = [].concat(address, sortDate, calculatedArea, assumedValue);
const ListSortItems_Market: SearchDropDownItem[] = [].concat(address, sortDate, calculatedArea, price);
const ListSortItems_NewDwellings: SearchDropDownItem[] = [].concat(regDate, projectName, percentageSold);

export const ListSortItems_Properties_SearchResult = structuredClone(ListSortItems_Properties);
export const ListSortItems_Market_SearchResult = structuredClone(ListSortItems_Market);
export const ListSortItems_NewDwellings_SearchResult = structuredClone(ListSortItems_NewDwellings);

export const ListSortItems_Properties_PopUpEstate = structuredClone(ListSortItems_Properties);
export const ListSortItems_Market_PopUpEstate = structuredClone(ListSortItems_Market);
export const ListSortItems_NewDwellings_PopUpEstate = structuredClone(ListSortItems_NewDwellings);

export const ListSortItems_Properties_FavouriteList = structuredClone(ListSortItems_Properties);
export const ListSortItems_Market_FavouriteList = structuredClone(ListSortItems_Market);
export const ListSortItems_NewDwellings_FavouriteList = structuredClone(ListSortItems_NewDwellings);

export function getSortList(origin: ListOrigin, mapMode: MapMode, option: SearchDropDownItem): SearchDropDownItem[] {
    let listItems: SearchDropDownItem[] = [];
    let idx = 0;

    switch (origin) {
        case ListOrigin.SearchResult:
            switch (mapMode) {
                case MapMode.Properties:
                    listItems = ListSortItems_Properties_SearchResult;
                    break;
                case MapMode.Market:
                    listItems = ListSortItems_Market_SearchResult;
                    break;
                case MapMode.NewDwellings:
                    listItems = ListSortItems_NewDwellings_SearchResult;
                    break;
                default:
                //throw
            }
            if (!option) {
                option = listItems[getDefaultSortOrderIndex(mapMode)];
            }
            break;
        case ListOrigin.PopUpEstate:
            switch (mapMode) {
                case MapMode.Properties:
                    listItems = ListSortItems_Properties_PopUpEstate;
                    break;
                case MapMode.Market:
                    listItems = ListSortItems_Market_PopUpEstate;
                    break;
                case MapMode.NewDwellings:
                    listItems = ListSortItems_NewDwellings_PopUpEstate;
                    break;
                default:
                //throw
            }
            break;

        case ListOrigin.FavouriteList:
            switch (mapMode) {
                case MapMode.Properties:
                    listItems = ListSortItems_Properties_FavouriteList;
                    break;
                case MapMode.Market:
                    listItems = ListSortItems_Market_FavouriteList;
                    break;
                case MapMode.NewDwellings:
                    listItems = ListSortItems_NewDwellings_FavouriteList;
                    break;
                default:
                //throw
            }
            break;
        default:
        //throw
    }
    idx = findIdx(listItems, option, mapMode);
    listItems.forEach((item) => (item.isSelected = false));
    if (listItems.length > 0) {
        listItems[idx].isSelected = true;
    }
    return listItems;
}
export function isKeyInList(origin: ListOrigin, mapMode: MapMode, option: SearchDropDownItem): boolean {
    const items = getSortList(origin, mapMode, null);
    items.forEach((item) => (item.isSelected = false));
    return items.findIndex((x) => x?.key === option?.key) !== -1;
}

export function getDefaultSortOrderIndex(mapMode: MapMode): number {
    return mapMode === MapMode.Properties ? propertiesDefault : mapMode === MapMode.Market ? marketDefault : newDwellingsDefault;
}
function findIdx(listItems: SearchDropDownItem[], option: SearchDropDownItem, mapMode: MapMode): number {
    let idx = 0;

    idx = listItems.findIndex((x) => x.key === option?.key);
    if (idx === -1) {
        idx = getDefaultSortOrderIndex(mapMode);
    }
    return idx;
}
